import React, { Component } from "react";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import LeaguesTable from "./leaguesTable";
import { getLeagues, deleteLeague } from "./../../services/leagueService";
import "react-confirm-alert/src/react-confirm-alert.css";
import _ from "lodash";

class Leagues extends Component {
  state = { leagues: [], sortColumn: { key: "name", order: "asc" } };

  async componentDidMount() {
    const leagues = await getLeagues();
    this.setState({ leagues });
  }

  handleDelete = async league => {
    confirmAlert({
      title: "Delete League",
      message: "Are you sure you want to delete '" + league.name + "'?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            const leagues = this.state.leagues.filter(s => s.id !== league.id);
            this.setState({ leagues });

            await deleteLeague(league.id);
          }
        },
        {
          label: "No",
          onClick: () => {}
        }
      ]
    });
  };

  handleSort = sortColumn => {
    this.setState({ sortColumn });
  };

  getSortedData = () => {
    const { leagues, sortColumn } = this.state;
    const sorted = _.orderBy(leagues, [sortColumn.key], [sortColumn.order]);
    return { leagues: sorted };
  };

  render() {
    const { sortColumn } = this.state;
    const { leagues } = this.getSortedData();

    return (
      <div>
        <h2>Leagues</h2>
        <Link
          to="/leagues/new"
          className="btn btn-primary"
          style={{ marginBottom: 20 }}
        >
          <i className="fa fa-file" />
        </Link>
        <LeaguesTable
          leagues={leagues}
          sortColumn={sortColumn}
          onEdit={this.handleEdit}
          onDelete={this.handleDelete}
          onSort={this.handleSort}
        />
      </div>
    );
  }
}

export default Leagues;



// WEBPACK FOOTER //
// ./src/components/leagues/leagues.jsx